import { render } from "./BrdcmSettingsPage.vue?vue&type=template&id=164e19b9&ts=true"
import script from "./BrdcmSettingsPage.vue?vue&type=script&lang=ts"
export * from "./BrdcmSettingsPage.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__